var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26pt",
    height: "18pt",
    viewBox: "0 0 26 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#717171d5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8B739B",
    opacity: 1,
    d: " M 0.00 8.41 C 2.92 4.19 7.56 0.57 12.94 0.83 C 18.34 0.60 23.17 4.10 26.00 8.48 L 26.00 9.59 C 23.06 13.85 18.38 17.47 12.96 17.17 C 7.59 17.37 2.81 13.86 0.00 9.52 L 0.00 8.41 M 8.40 3.52 C 5.85 4.66 3.43 6.60 2.03 8.95 C 3.60 11.82 6.75 14.16 10.01 15.03 C 15.34 16.55 21.30 13.54 23.97 8.99 C 21.03 3.89 14.03 0.96 8.40 3.52 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "#737373d9"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8B739B",
    opacity: 1,
    d: " M 11.30 4.32 C 14.33 3.02 18.20 5.77 18.01 9.07 C 17.98 12.54 13.78 15.42 10.70 13.33 C 6.78 11.70 7.43 5.55 11.30 4.32 M 11.53 6.08 C 9.74 7.02 9.20 9.82 10.73 11.18 C 12.39 13.31 16.55 11.76 16.12 8.97 C 16.35 6.55 13.57 5.25 11.53 6.08 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.2848810314c933bdd39b57ea044d6db1.svg";
export { ForwardRef as ReactComponent };